const {registerModule} = window;

class NavigationBar {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  bindEvents() {
    if (this.isStickyNav && this.ui.$featuredNavigationItem) {
      this.handleHorizontalScroll();
      this.ui.$navigation.addEventListener('scroll', this.handleHorizontalScroll.bind(this));
    } else if (!this.isStickyNav) {
      this.ui.$next.addEventListener('click', this.handleClickNext.bind(this));
      this.ui.$prev.addEventListener('click', this.handleClickPrev.bind(this));
      this.ui.$searchButton.addEventListener('click', this.handleOpenSearch.bind(this));
      this.ui.$searchButton.addEventListener('click', this.handleOpenSearch.bind(this));
    }
    window.addEventListener('DOMContentLoaded', this.handleDomLoaded.bind(this));
  }

  bindExternalUI() {
    this.externalUi = {};
    this.externalUi.$searchModal = document.querySelector(`[data-modal-id="${this.modalId}"]`);
  }

  bindIntersectionObservers() {
    const options = {
      root: this.ui.$wrapper,
      threshold: 0.9,
      rootMargin: '200px 0px 200px 0px',
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.dataset.isVisible = entry.isIntersecting;
      });

      const visibleItems = this.ui.$listItems.filter(($listItem) => (
        $listItem.dataset.isVisible === 'true'
      ));

      const indexPrevious = this.ui.$listItems.indexOf(visibleItems[0]) - 1;
      const indexNext = this.ui.$listItems.indexOf(visibleItems[visibleItems.length - 1]) + 1;

      this.previousItem = indexPrevious >= 0 ? this.ui.$listItems[indexPrevious] : undefined;
      this.nextItem = indexNext >= 0 ? this.ui.$listItems[indexNext] : undefined;

      this.updateUI();
    }, options);

    this.ui.$listItems.forEach(($listItem) => {
      observer.observe($listItem);
    });
  }

  bindUI() {
    this.ui = {};
    this.ui.$navigationWrapper = this.element.querySelector('.navigation-wrapper');
    this.ui.$navigation = this.element.querySelector('.navigation');
    this.ui.$featuredNavigationItem = this.element.querySelector('.navigation__featuredItem');
    this.ui.$activeItem = this.element.querySelector('[data-ref="active-item"]');
    this.ui.$list = this.element.querySelector('[data-ref="list"]');
    this.ui.$listItems = Array.from(this.ui.$list.querySelectorAll('li'));
    this.ui.$next = this.element.querySelector('[data-ref="next"]');
    this.ui.$prev = this.element.querySelector('[data-ref="prev"]');
    this.ui.$searchButton = this.element.querySelector('[data-ref="search"]');
    this.ui.$wrapper = this.element.querySelector('[data-ref="wrapper"]');
    this.ui.$currentItem = this.ui.$list.querySelector('.navigation__list-item--active');
  }

  handleDomLoaded() {
    this.ui.$currentItem?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  }

  handleClickNext() {
    this.nextItem?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  }

  handleClickPrev() {
    this.previousItem?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  }

  handleOpenSearch() {
    const event = new Event('showmodal');
    this.externalUi.$searchModal?.dispatchEvent(event);
  }

  handleHorizontalScroll() {
    const navRightEdge = this.ui.$navigation.getBoundingClientRect().right;
    const featuredRightEdge = this.ui.$featuredNavigationItem.getBoundingClientRect().right;
    if (featuredRightEdge - 1 <= navRightEdge) {
      this.ui.$navigationWrapper.style.setProperty('--afterFadeOpacity', '0');
    } else {
      this.ui.$navigationWrapper.style.setProperty('--afterFadeOpacity', '0.5');
    }
  }

  initialize() {
    this.bindUI();
    this.setVars();
    this.bindExternalUI();
    this.bindIntersectionObservers();
    this.bindEvents();
    this.scrollToActiveItem();
  }

  scrollToActiveItem() {
    if (!this.ui.$activeItem) {
      return;
    }

    this.ui.$activeItem.scrollIntoView({
      block: 'nearest',
      inline: 'center',
    });
  }

  setVars() {
    this.modalId = this.element.dataset.modalId;
    this.isStickyNav = this.element.classList.contains('navigationBar--stickyNav');
  }

  updateUI() {
    const isOverflowedLeft = this.ui.$listItems[0]?.dataset.isVisible === 'false';
    const isOverflowedRight = this.ui.$listItems[this.ui.$listItems.length - 1]?.dataset.isVisible === 'false';

    this.element.dataset.isOverflowedLeft = isOverflowedLeft;
    this.element.dataset.isOverflowedRight = isOverflowedRight;
  }
}

registerModule('NavigationBar', NavigationBar);
